import { createSlice } from '@reduxjs/toolkit';
import { bulletinInitialState } from './initialState/bulletinInitialState';
import { fetchBulletins, removeBulletin } from './actions';

export const bulletinSlice = createSlice({
  name: 'bulletinSlice',
  initialState: bulletinInitialState,
  reducers: {
    setSelectedBulletinIds: (state, action) => {
      state.selectedBulletinIds = action.payload;
    },
    changeBulletinValue: (state, action) => {
      const { id, key, value } = action.payload;
      state.bulletins.data.forEach((item, index) => {
        if (item.id === id) {
          state.bulletins.data[index][key] = value;
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBulletins.fulfilled, (state, action) => {
        const { data, total } = action.payload;

        state.bulletins.data = data;
        state.bulletins.loading = false;
        state.bulletins.error = null;
        state.bulletins.total = total;
      })
      .addCase(fetchBulletins.pending, (state) => {
        state.bulletins.loading = true;
        state.bulletins.error = null;
      })
      .addCase(fetchBulletins.rejected, (state, action) => {
        state.bulletins.loading = false;
        state.bulletins.error = action.payload;
      })
      .addCase(removeBulletin.fulfilled, (state) => {
        state.removeBulletins.loading = false;
        state.removeBulletins.error = null;
      })
      .addCase(removeBulletin.pending, (state) => {
        state.removeBulletins.loading = true;
        state.removeBulletins.error = null;
      })
      .addCase(removeBulletin.rejected, (state, action) => {
        state.removeBulletins.loading = false;
        state.removeBulletins.error = action.payload;
      });
  },
});

export const { setSelectedBulletinIds, changeBulletinValue } =
  bulletinSlice.actions;
